/* src/app/workshop/modals/defect-reject-modal/defect-reject-modal.component.scss */
/*# sourceMappingURL=defect-reject-modal.component.css.map */
